import { Injectable } from '@angular/core';
import {HttpHelperService} from "./http-helper.service";
import {ContactForm} from "./models/ContactForm";
import {ApiResult} from "./models/ApiResult";
import {NotificationMessageResult} from "./models/notifications/NotificationMessageResult";

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private httpHelper: HttpHelperService) { }

  public send(form: ContactForm) : Promise<NotificationMessageResult> {
    return new Promise<NotificationMessageResult>((resolve, reject) => {
      this.httpHelper.post<ApiResult>("contact", form)
        .then(result => resolve(new NotificationMessageResult(result)))
        .catch(error => reject(error));
    });
  }
}
